import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { modals, getFIO } from 'helpers'

import Row from 'components/layout/Row/Row'
import Box from 'components/layout/Box/Box'
import Text from 'components/typography/Text/Text'
import Button from 'components/ui/Button/Button'
import HeroModal from 'components/HeroModal/HeroModal'
import ImageContainer from 'layers/heroes/components/ImageContainer/ImageContainer'

import s from './HeroViewModal.scss'

import logoImage from './images/logo.svg'
import Media from '../../../local_modules/Media/client'


class HeroViewModal extends PureComponent {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
  }

  static defaultProps = {
    name: modals.HeroView,
  }

  componentDidMount() {
    window.dispatchEvent(new Event('resize'))
  }

  close = () => {
    const { name } = this.props

    actions.modals.close(name)
  }

  handleButtonClick = (link) => {
    const { data: { onButtonClick } } = this.props

    this.close()
    window.open(link, '_blank')

    if (typeof onButtonClick === 'function') {
      onButtonClick()
    }
  }

  render() {
    const { data: { id, firstName, lastName, middleName, sign, gender, birth, death, description, image } } = this.props

    const FIO   = getFIO({ firstName, lastName, middleName })
    const dates = death ? `${birth} - ${death}` : birth
    const link  = `https://pamyat-naroda.ru/heroes/?adv_search=y&last_name=${lastName}&group=all&types=pamyat_commander:nagrady_nagrad_doc:nagrady_uchet_kartoteka:nagrady_ubilein_kartoteka:pamyat_voenkomat:potery_vpp:pamyat_zsp_parts:kld_upk:kld_vmf:potery_doneseniya_o_poteryah:potery_gospitali:potery_utochenie_poter:potery_spiski_zahoroneniy:potery_voennoplen:potery_iskluchenie_iz_spiskov&page=1&first_name=${firstName}&middle_name=${middleName}`

    return (
      <Media mobile>
        {
          (isMobile) => (
            <HeroModal
              onClose={this.close}
            >
              {
                isMobile ? (
                  <div>
                    <Box relative>
                      <img className={s.logo} src={logoImage} />
                      <ImageContainer
                        className={s.image}
                        gender={gender}
                        src={image}
                        w={270}
                        alt={FIO}
                      />
                    </Box>
                    <Box className={s.content} mt={16}>
                      <Text message={lastName} size="30-36" color="darkRed" semibold />
                      <Text message={firstName} size="30-36" color="darkRed" semibold />
                      <Text message={middleName} size="30-36" color="darkRed" semibold />
                      <Box mt={20}>
                        <Text message={dates} size="30-36" color="darkRed" />
                      </Box>
                      {
                        Boolean(sign) && (
                          <Box mt={20}>
                            <Box
                              className={s.rank}
                              ph={24}
                              pv={12}
                            >
                              <Text message={sign} size="22-26" color="white" />
                            </Box>
                          </Box>
                        )
                      }
                    </Box>
                  </div>
                ) : (
                  <Row align="start" justify="start">
                    <Box relative>
                      <img className={s.logo} src={logoImage} />
                      <ImageContainer
                        className={s.image}
                        gender={gender}
                        src={image}
                        w={270}
                        alt={FIO}
                      />
                    </Box>
                    <Box className={s.content} ml={36} mt={80}>
                      <Text message={lastName} size="30-36" color="darkRed" semibold />
                      <Text message={firstName} size="30-36" color="darkRed" semibold />
                      <Text message={middleName} size="30-36" color="darkRed" semibold />
                      <Box mt={20}>
                        <Text message={dates} size="30-36" color="darkRed" />
                      </Box>
                      {
                        Boolean(sign) && (
                          <Box mt={20}>
                            <Box
                              className={s.rank}
                              ph={24}
                              pv={12}
                            >
                              <Text message={sign} size="22-26" color="white" />
                            </Box>
                          </Box>
                        )
                      }
                    </Box>
                  </Row>
                )
              }
              {
                Boolean(description) && (
                  <Box pt={48}>
                    <Text message={description.replace(/\n/g, '<br />')} size="18-21" color="darkRed" />
                  </Box>
                )
              }
              <Box pt={48}>
                <Button
                  color="gold"
                  size="lg"
                  fullWidth
                  onClick={() => this.handleButtonClick(link)}
                >
                  <Box pv={16}>
                    <Text
                      message="Узнать больше на pamyat-naroda.ru"
                      color="white"
                      size="22-26"
                      semibold
                    />
                  </Box>
                </Button>
              </Box>
            </HeroModal>
          )
        }
      </Media>
    )
  }
}


export default HeroViewModal
